module.exports = __webpack_public_path__ + "img/logo.8b63254a.png";